import * as echarts from 'echarts';
import { ConsumptionFilter } from '../../stores/consumption.store';
import { ConsumptionData } from './util';
import { TranslocoService } from '@jsverse/transloco';
import { TopLevelFormatterParams } from 'echarts/types/dist/shared';
import { parse } from 'date-fns';
import { render } from '../../../../core/helper/render';
import { ViewContainerRef } from '@angular/core';
import { AnalysisConsumptionGraphTooltip } from '../../components/analysis-consumption-graph-tooltip/analysis-consumption-graph-tooltip';
import { getXLabel, getInterval } from '../util';

export const getLineConfig = (
  dependencies: { translocoService: TranslocoService; vcr: ViewContainerRef },
  data: ConsumptionData,
  options: {
    colors: {
      line: string;
      areaStop1: string;
      areaStop2: string;
    };
    granularity: ConsumptionFilter['granularity'];
  },
): echarts.EChartsOption => ({
  grid: {
    left: 56,
    right: 24,
    top: 40,
    bottom: 44,
  },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    data: data.xAxisData,
    axisTick: {
      show: false,
    },
    axisLabel: {
      hideOverlap: true,
      interval: (index: number, value: string) => getInterval(value, options.granularity),
      formatter: (value: string) => getXLabel(value, options.granularity),
    },
  },
  yAxis: {
    type: 'value',
    name: dependencies.translocoService.translate('cockpit.analysis.consumption.graph.yAxisLabel'),
  },
  tooltip: {
    trigger: 'axis',
    position: (pt: [number, number]) => [pt[0], '10%'],
    formatter: (params: TopLevelFormatterParams) => {
      const param = Array.isArray(params) ? params[0] : params;
      const timestamp = parse(
        (param as unknown as { axisValue: string })['axisValue'],
        'yyyy-MM-dd HH:mm',
        new Date(),
      );
      const value = param.value;
      return render(dependencies.vcr, AnalysisConsumptionGraphTooltip, {
        timestamp,
        value,
        granularity: options.granularity,
        graphView: 'line',
      });
    },
  },
  series: [
    {
      type: 'line',
      smooth: 0.25,
      symbol: 'none',
      emphasis: {
        disabled: true,
      },
      data: data.yAxisData,
      lineStyle: {
        color: options.colors.line,
        width: 2,
        type: 'solid',
      },
      itemStyle: {
        color: options.colors.line,
      },
      areaStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: options.colors.areaStop1,
            },
            {
              offset: 1,
              color: options.colors.areaStop2,
            },
          ],
        },
      },
    },
  ],
});
